"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SliderInput;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SliderInput(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '70%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: props.label,
    name: props.name,
    component: _cccisdFormik.CccisdInput,
    type: "range",
    min: props.min,
    max: props.max,
    step: props.step,
    style: {
      padding: 0
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1.5em',
      width: '30%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "",
    name: props.name,
    component: _cccisdFormik.CccisdInput,
    type: "number",
    min: props.min,
    max: props.max,
    step: props.step
  })));
}